import React from 'react';
import './StatusBadge.scss';
import { ChannelType } from '../model';

interface BadgeProps {
  badgeTitle: string;
}

const Badge: React.FC<BadgeProps> = ({ badgeTitle }) => {
  let className = 'status-badge default';
  let label = badgeTitle;

  switch (badgeTitle) {
    case 'AWAITING_FILE_UPLOAD':
      className = 'status-badge awaiting';
      label = 'Awaiting File Upload';
      break;
    case 'INACTIVE':
      className = 'status-badge awaiting';
      label = 'Inactive';
      break;
    case 'READY':
      className = 'status-badge ready';
      label = 'Ready';
      break;
    case 'ACTIVE':
      className = 'status-badge ready';
      label = 'Active';
      break;
    case 'DISCONNECTED':
      className = 'status-badge orange';
      label = 'Not connected';
      break;
    case 'CONNECTED':
      className = 'status-badge green';
      label = 'Connected';
      break;
    case ChannelType.TELEGRAM:
      className = 'status-badge green';
      break;
    case ChannelType.WEBHOOK:
      className = 'status-badge blue';
      break;
    default:
      className = 'status-badge green';
      break;
  }

  return <span className={className}>{label}</span>;
};

export default Badge;
